import { AdminTypes } from './AdminTypes';

const initalState = { loading: true };

type Action = {
    type: AdminTypes,
    payload?: any
}

export const adminReducer = (state = initalState, action: Action) => {
    const dictionary = {
        [AdminTypes.login]: () => {
            return {
                ...action.payload,
                logged: true,
                loading: false,
            };
        },
        [AdminTypes.logout]: () => ({
            logged: false,
            loading: false,
        }),
        // Refresca en caliente el snapshot de permisos del usuario logueado
        // sin re-login (DBSB-458). Merge: preserva el resto de adminState.
        [AdminTypes.updatePermisos]: () => ({
            ...state,
            Permisos: action.payload,
        })
    };

    return dictionary[action.type]() || state;
};